/** Welcome pack sections — set each `body` to the final copy. */
export const RESERVE_WELCOME_PACK_SECTIONS = [
  {
    id: 'what_reserve_is',
    title: 'What Reserve Is',
    body: `Membership is selective

AXONALL RESERVE

Axonall Reserve is a private circle of selected luxury travel advisors brought together by a shared belief that the future of high-value travel will be shaped by stronger curation, more intelligent systems, and a higher standard of access. It is a place for those who will shape the future of luxury travel.

WHAT MAKES RESERVE DIFFERENT
· A highly selective membership, not open trade access.
· Curated travel opportunities shaped around quality, distinction, and harder-to-find access.
· Journey Artisan support behind every booking, bringing a high-touch human layer alongside the platform.
· Trusted professional exchange, insight, and a closer place in the conversations shaping what comes next in high-value travel.

WHAT RESERVE IS NOT
· Not a host agency.
· Not an affiliate network.
· Not a generic booking portal.
· Not a public advisor marketplace.

WHO IT IS FOR
Reserve is best suited to luxury travel advisors serving affluent and high-value clients who value curation, discretion, service, and a more distinctive way of working.`,
  },
  {
    id: 'axonall_reserve_vs_studio',
    title: 'Axonall Reserve vs Studio',
    body: '',
    layout: 'reserve_vs_studio',
  },
  {
    id: 'membership_benefits',
    title: 'Membership benefits',
    body: '',
    layout: 'membership_benefits',
  },
  {
    id: 'journey_artisan_support',
    title: 'Journey & Artisan support',
    body: '',
    layout: 'journey_artisan_support',
  },
  {
    id: 'black_key_private_note',
    title: 'Black Key private note',
    body: '',
    layout: 'black_key_access',
  },
  {
    id: 'member_expectations',
    title: 'Member expectations',
    body: '',
    layout: 'member_expectations',
  },
]

export const RESERVE_MEMBERSHIP_GUIDE_PATH = '/profile/reserve-membership-guide'

export const RESERVE_WELCOME_PACK_PATH = `${RESERVE_MEMBERSHIP_GUIDE_PATH}/welcome-pack`

export function getReserveWelcomePackSection(topicId) {
  return RESERVE_WELCOME_PACK_SECTIONS.find((s) => s.id === topicId) ?? null
}

export const RESERVE_WELCOME_PACK_DEFAULT_TOPIC_ID =
  RESERVE_WELCOME_PACK_SECTIONS[0]?.id ?? 'what_reserve_is'

export const RESERVE_WELCOME_PACK_LAST_TOPIC_ID =
  RESERVE_WELCOME_PACK_SECTIONS[RESERVE_WELCOME_PACK_SECTIONS.length - 1]?.id ?? ''

/** When body opens with the standard kicker + brand, peel them off for the centered masthead. */
export function extractReserveWelcomePackMasthead(body) {
  if (!body || typeof body !== 'string') {
    return { hasMasthead: false, kicker: '', brand: '', rest: body || '' }
  }
  const chunks = body.split(/\n\n+/).map((c) => c.trim()).filter(Boolean)
  if (chunks.length < 3) {
    return { hasMasthead: false, kicker: '', brand: '', rest: body }
  }
  const kickerNorm = chunks[0].toLowerCase().replace(/\s+/g, ' ')
  const brandNorm = chunks[1].toUpperCase().replace(/\s+/g, ' ').trim()
  if (kickerNorm === 'membership is selective' && brandNorm === 'AXONALL RESERVE') {
    return {
      hasMasthead: true,
      kicker: chunks[0],
      brand: chunks[1],
      rest: chunks.slice(2).join('\n\n'),
    }
  }
  return { hasMasthead: false, kicker: '', brand: '', rest: body }
}
